/*
  Conso — Área do cliente (/pages/area-de-membros)

  <conso-area-shell>: navegação em abas SEM recarregar a página.
    - Cada aba (button[data-conso-tab]) aponta pra 1+ sections do template
      (data-panel="id1,id2" → #shopify-section-id1 ...).
    - Ativa/desativa via atributo data-conso-active na section (o CSS inline do
      shell esconde o que não está ativo). Marca .conso-area-ready no wrapper do
      shell pra liberar a regra do primeiro painel.
    - URL por hash (#pedidos) com pushState: voltar troca de aba; links
      <a href="#pedidos"> em qualquer lugar da página trocam a aba.
    - Login descarta o hash: guarda a aba desejada em sessionStorage antes de
      ir pro login e restaura ao voltar.
    - refreshPanel(id): recarrega só uma section via Section Rendering API
      (?sections=id) — pra painéis que mudam após uma ação, sem reload.
    - Eventos GA4 (dataLayer): conso_area_view, conso_area_tab, conso_area_login_click.
    - Vistas (abas escondidas): a 1ª aba é a vista inicial; as outras marcam
      <html data-conso-subview> e o CSS as abre como gaveta de tela cheia no
      mobile. [data-conso-voltar] fecha: volta no histórico quando a gaveta foi
      aberta daqui (o "voltar" do celular faz o mesmo), senão troca direto.
      A rolagem da vista inicial é guardada e restaurada ao fechar.

  <conso-area-cupom>: copia o código ao clicar.

  Marca de cashback em dobro: todo add-to-cart feito NESTA página (logado) grava o
  atributo de carrinho `_conso_area_membros`. Ele vai pro pedido em note_attributes e
  a lambda consolatio-cashback dobra o cashback do PEDIDO INTEIRO. Pega os três
  caminhos de add (form nativo, conso-kit-opcoes, conso-area-brinde) observando o
  fetch em vez de acoplar em cada um. O "_" esconde o atributo no checkout.

  Marca de compra pela área: o mesmo add também grava em CADA LINHA adicionada a
  property `_conso_area_membros`. O webhook orders/paid do app consolatio-discounts
  (lib/compra-membros.server.ts) lê a property da linha, não o atributo do carrinho,
  pra só dar a tag `compra-area-de-membros` a quem comprou item DESTA página.
*/
(function () {
  'use strict';

  var STORAGE_TAB = '__conso_area_tab';

  /* Quem rola a página. No desktop (>= 990px) o Horizon rola o `.page-wrapper`
     (height: 100dvh; overflow-y: auto, em base.css), não a janela — e aí
     window.scrollTo/scrollY não fazem nada. No mobile é a janela. */
  function rolador() {
    var pw = document.querySelector('.page-wrapper');
    if (pw && pw.scrollHeight > pw.clientHeight) {
      var oy = getComputedStyle(pw).overflowY;
      if (oy === 'auto' || oy === 'scroll') return pw;
    }
    return null;
  }
  function posicaoRolagem() {
    var r = rolador();
    return r ? r.scrollTop : window.scrollY;
  }
  /* behavior 'instant' passa por cima do scroll-behavior: smooth do tema. */
  function rolarPara(y, suave) {
    var r = rolador();
    var o = { top: y, behavior: suave ? 'smooth' : 'instant' };
    if (r) r.scrollTo(o);
    else window.scrollTo(o);
  }

  function push(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function perfilInfo() {
    var p = window.__consoPerfil || {};
    return {
      perfil: p.perfil || '',
      logado: p.logado ? 1 : 0,
      compras: typeof p.compras === 'number' ? p.compras : undefined
    };
  }

  function readSession(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function writeSession(key, value) {
    try {
      if (value == null) window.sessionStorage.removeItem(key);
      else window.sessionStorage.setItem(key, value);
    } catch (e) { /* storage bloqueado */ }
  }

  /* ------------------------------------------- card de kit ao abrir a aba */
  /* Aba com "Card de kit ao abrir" marca o radio "1 unidade" (value 1) ou o do
     kit (value > 1) das Opções de kit (conso-kit-opcoes) dos painéis dela. O
     change sobe pro <conso-kit-opcoes>, que troca o preço e o CTA sozinho. */
  /* Vídeo (galeria do produto, deferred-media do Horizon, iframe do YouTube/Vimeo)
     continuaria tocando escondido quando a aba fecha: pausa o que está no painel. */
  function pausarMidias(panel) {
    panel.querySelectorAll('deferred-media, product-model').forEach(function (m) {
      if (typeof m.pauseMedia === 'function' && m.getAttribute('data-media-loaded')) m.pauseMedia();
    });
    panel.querySelectorAll('video').forEach(function (v) { if (!v.paused) v.pause(); });
    panel.querySelectorAll('iframe').forEach(function (f) {
      var src = f.getAttribute('src') || '';
      if (!f.contentWindow) return;
      if (/youtube/.test(src)) f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      else if (/vimeo/.test(src)) f.contentWindow.postMessage('{"method":"pause"}', '*');
    });
  }

  function marcarKitPadrao(tab, paineis) {
    var alvo = tab.getAttribute('data-kit-padrao');
    if (!alvo) return;
    paineis.forEach(function (panel) {
      panel.querySelectorAll('conso-kit-opcoes').forEach(function (ko) {
        var radios = Array.prototype.slice.call(ko.querySelectorAll('input[data-co-ko-tier]'));
        var radio = radios.filter(function (r) {
          var n = parseInt(r.value, 10) || 1;
          return alvo === 'kit' ? n > 1 : n === 1;
        })[0];
        if (!radio || radio.checked) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ------------------------------------------------- cashback em dobro */
  var ATTR_MEMBROS = '_conso_area_membros';
  (function marcarCarrinho() {
    if (window.__consoAreaMarca || typeof window.fetch !== 'function') return;
    window.__consoAreaMarca = true;
    var fetchOriginal = window.fetch;

    function logado() {
      return document.documentElement.getAttribute('data-conso-logado') === '1' &&
        !(window.__consoPerfil && window.__consoPerfil.preview);
    }

    function marcar() {
      var attrs = {};
      attrs[ATTR_MEMBROS] = '1';
      return fetchOriginal.call(window, '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () { /* sem a marca o pedido só não ganha o dobro */ });
    }

    /* Valor da property de linha: o perfil de quem comprou (novo, recorrente,
       fiel). O webhook orders/paid só exige que não seja vazio; a function
       promo-membros-camisetas lê o valor pra liberar o frete grátis de quem já
       comprou. O atributo de carrinho (cashback em dobro) continua '1'. */
    function marcaLinha() {
      return perfilInfo().perfil || '1';
    }

    /* Property de linha em cada item do add. Os dois formatos que passam aqui:
       FormData (form nativo) e JSON com `items` (kit, brinde, camisetas) ou `id`. */
    function marcarLinhas(init) {
      if (!init || !init.body) return;
      var corpo = init.body;
      if (typeof FormData !== 'undefined' && corpo instanceof FormData) {
        corpo.set('properties[' + ATTR_MEMBROS + ']', marcaLinha());
        return;
      }
      if (typeof corpo !== 'string') return;
      try {
        var dados = JSON.parse(corpo);
        var itens = Array.isArray(dados.items) ? dados.items : (dados.id ? [dados] : []);
        if (!itens.length) return;
        itens.forEach(function (item) {
          item.properties = item.properties || {};
          item.properties[ATTR_MEMBROS] = marcaLinha();
        });
        init.body = JSON.stringify(dados);
      } catch (e) { /* corpo que não é JSON: segue sem a marca */ }
    }

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var metodo = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var ehAdd = metodo === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url.replace(location.origin, ''));
      if (ehAdd && logado()) marcarLinhas(init);
      var resp = fetchOriginal.apply(this, arguments);
      if (!ehAdd || !logado()) return resp;
      return resp.then(function (r) {
        if (r && r.ok) {
          marcar();
          push({ event: 'conso_area_add', area_perfil: perfilInfo().perfil });
        }
        return r;
      });
    };
  })();

  /* -------------------------------------------------------------- shell */
  if (!customElements.get('conso-area-shell')) {
    class ConsoAreaShell extends HTMLElement {
      constructor() {
        super();
        this.onTabClick = this.onTabClick.bind(this);
        this.onDocClick = this.onDocClick.bind(this);
        this.onPopState = this.onPopState.bind(this);
        this.current = null;
        this.homeScroll = 0;
        this.abertaDaqui = false;
      }

      connectedCallback() {
        this.wrapper = this.closest('[id^="shopify-section-"]');
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-conso-tab]'));
        this.logado = this.getAttribute('data-logado') === '1';

        var login = this.querySelector('[data-conso-login]');
        if (login) {
          login.addEventListener('click', function () {
            var hash = (location.hash || '').replace('#', '');
            if (hash) writeSession(STORAGE_TAB, hash);
            push({ event: 'conso_area_login_click', area_perfil: 'deslogado' });
          });
        }

        var info = perfilInfo();
        push({
          event: 'conso_area_view',
          area_perfil: info.logado ? info.perfil : 'deslogado',
          area_logado: info.logado,
          area_compras: info.compras
        });

        if (!this.tabs.length) return;

        this.tabs.forEach(function (tab) { tab.addEventListener('click', this.onTabClick); }, this);
        document.addEventListener('click', this.onDocClick);
        window.addEventListener('popstate', this.onPopState);

        var pending = readSession(STORAGE_TAB);
        if (pending) writeSession(STORAGE_TAB, null);
        var fromHash = (location.hash || '').replace('#', '');
        var initial = this.tabFor(pending) || this.tabFor(fromHash) || this.tabs[0];

        if (this.wrapper) this.wrapper.classList.add('conso-area-ready');
        this.activate(initial, { history: fromHash ? 'none' : 'replace', scroll: false, track: false });
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
        window.removeEventListener('popstate', this.onPopState);
      }

      tabFor(hash) {
        if (!hash) return null;
        for (var i = 0; i < this.tabs.length; i++) {
          if (this.tabs[i].dataset.hash === hash) return this.tabs[i];
        }
        return null;
      }

      panelsOf(tab) {
        return (tab.dataset.panel || '')
          .split(',')
          .map(function (id) { return id.trim(); })
          .filter(Boolean)
          .map(function (id) { return document.getElementById('shopify-section-' + id); })
          .filter(Boolean);
      }

      onTabClick(event) {
        var tab = event.currentTarget;
        this.activate(tab, { history: 'push', scroll: true, track: true });
      }

      /* <a href="#pedidos"> em qualquer section da página troca a aba */
      onDocClick(event) {
        var voltar = event.target.closest && event.target.closest('[data-conso-voltar]');
        if (voltar) {
          event.preventDefault();
          if (this.abertaDaqui && history.state && history.state.consoTab) {
            history.back();
          } else {
            this.activate(this.tabs[0], { history: 'replace', scroll: true, track: true });
          }
          return;
        }
        var a = event.target.closest && event.target.closest('a[href^="#"]');
        if (!a) return;
        var tab = this.tabFor(a.getAttribute('href').slice(1));
        if (!tab) return;
        event.preventDefault();
        this.abertaDaqui = this.current === this.tabs[0] && tab !== this.tabs[0];
        this.activate(tab, { history: 'push', scroll: true, track: true });
      }

      onPopState() {
        var tab = this.tabFor((location.hash || '').replace('#', '')) || this.tabs[0];
        if (tab === this.tabs[0]) this.abertaDaqui = false;
        this.activate(tab, { history: 'none', scroll: this.hasAttribute('data-vistas'), track: false });
      }

      activate(tab, opts) {
        if (!tab) return;
        opts = opts || {};
        var self = this;
        var home = this.tabs[0];
        var sub = tab !== home;
        var vistas = this.hasAttribute('data-vistas');
        var root = document.documentElement;
        var saindoDaHome = sub && this.current === home;
        if (saindoDaHome) this.homeScroll = posicaoRolagem();
        var apply = function () {
          /* Uma section pode estar em mais de uma aba (ex.: os mesmos produtos
             na vista de 15% e na de leve 3 pague 2): desliga tudo antes e liga
             só os painéis da aba ativa, senão a ordem das abas decidiria. */
          var ativos = self.panelsOf(tab);
          self.tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            t.tabIndex = on ? 0 : -1;
            self.panelsOf(t).forEach(function (panel) {
              if (ativos.indexOf(panel) === -1 && panel.hasAttribute('data-conso-active')) {
                panel.removeAttribute('data-conso-active');
                pausarMidias(panel);
              }
            });
          });
          ativos.forEach(function (panel) { panel.setAttribute('data-conso-active', ''); });
          marcarKitPadrao(tab, ativos);
          root.setAttribute('data-conso-view', tab.dataset.hash);
          if (sub) root.setAttribute('data-conso-subview', '');
          else root.removeAttribute('data-conso-subview');
          /* No modo vistas a rolagem muda DENTRO da transição, pro quadro novo
             já nascer no lugar certo (gaveta no topo, home onde estava). */
          if (vistas && opts.scroll) rolarPara(sub ? 0 : self.homeScroll, false);
        };

        var changed = this.current !== tab;
        this.current = tab;

        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (changed && document.startViewTransition && !reduce) {
          root.setAttribute('data-conso-vt', sub ? 'abre' : 'fecha');
          var vt = document.startViewTransition(apply);
          vt.finished.finally(function () { root.removeAttribute('data-conso-vt'); });
        } else {
          apply();
        }

        var hash = tab.dataset.hash;
        if (opts.history === 'push' && location.hash !== '#' + hash) {
          history.pushState({ consoTab: hash }, '', '#' + hash);
        } else if (opts.history === 'replace') {
          history.replaceState({ consoTab: hash }, '', location.pathname + location.search + '#' + hash);
        }

        if (vistas) {
          /* rolagem já tratada no apply */
        } else if (opts.scroll && window.matchMedia('(max-width: 767px)').matches === false) {
          /* desktop: leva o topo do conteúdo até logo abaixo das abas */
          var atual = posicaoRolagem();
          var top = this.getBoundingClientRect().top + atual - 12;
          if (atual > top) rolarPara(top, !reduce);
        } else if (opts.scroll) {
          rolarPara(0, !reduce);
        }

        if (opts.track && changed) {
          var info = perfilInfo();
          push({ event: 'conso_area_tab', area_aba: hash, area_perfil: info.perfil });
        }

        this.panelsOf(tab).forEach(function (panel) {
          panel.dispatchEvent(new CustomEvent('conso:area:panel', { bubbles: true, detail: { hash: hash, section: panel.id } }));
        });
      }

      /* Recarrega uma section do template pela Section Rendering API. */
      refreshPanel(sectionId) {
        var panel = document.getElementById('shopify-section-' + sectionId);
        if (!panel) return Promise.resolve(false);
        var url = location.pathname + '?sections=' + encodeURIComponent(sectionId);
        return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (json) {
            var html = json && json[sectionId];
            if (!html) return false;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.getElementById('shopify-section-' + sectionId);
            if (!fresh) return false;
            panel.innerHTML = fresh.innerHTML;
            return true;
          })
          .catch(function () { return false; });
      }
    }
    customElements.define('conso-area-shell', ConsoAreaShell);
  }

  /* -------------------------------------------------------------- cupom */
  if (!customElements.get('conso-area-cupom')) {
    class ConsoAreaCupom extends HTMLElement {
      connectedCallback() {
        var btn = this.querySelector('[data-conso-cupom-copy]');
        var feedback = this.querySelector('[data-conso-cupom-feedback]');
        var code = this.dataset.code || '';
        if (!btn || !code) return;
        btn.addEventListener('click', function () {
          if (!navigator.clipboard) return;
          navigator.clipboard.writeText(code).then(function () {
            if (feedback) feedback.textContent = 'Cupom copiado ✓';
            var info = perfilInfo();
            push({ event: 'conso_area_cupom_copy', area_cupom: code, area_perfil: info.perfil });
            setTimeout(function () { if (feedback) feedback.textContent = ''; }, 1800);
          }).catch(function () {});
        });
      }
    }
    customElements.define('conso-area-cupom', ConsoAreaCupom);
  }

  /* ------------------------------------------- banner deslogado → cadastro */
  /* Deslogado com o form de cadastro na página: o banner rola até o form (o Clarity
     mostrou clique sem resposta na arte, nov/2026). Sem href "#…" de propósito: o hash
     da URL é das abas. Logado não tem .conso-area__cadastro, então o banner fica parado. */
  (function () {
    var cad = document.querySelector('.conso-area__cadastro');
    var banner = cad && document.querySelector('conso-area-shell .conso-area__banner');
    if (!banner) return;
    banner.setAttribute('data-conso-rolar-cadastro', '');
    banner.setAttribute('role', 'button');
    banner.setAttribute('tabindex', '0');
    banner.setAttribute('aria-label', 'Ir para o cadastro');
    function ir() {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var header = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
      var top = cad.getBoundingClientRect().top + posicaoRolagem() - header - 12;
      rolarPara(Math.max(0, top), !reduce);
    }
    banner.addEventListener('click', ir);
    banner.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); ir(); }
    });
  })();
})();
